import React from 'react'
import Header from '../Component/Header'
import Footer from '../Component/Footer'

function About() {
    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#FFFFFF" }}>
                <div className="container py-5"></div>
                {/* About Start */}
                <div className="container-xxl py-5">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="row g-3 img-twice position-relative h-100">
                                <div className="col-6">
                                    <img className="img-fluid p-3" style={{ backgroundColor: "#f8f9fa" }} src="img/About/01.jpg" alt />
                                </div>
                                <div className="col-6 align-self-end">
                                    <img className="img-fluid p-3" style={{ backgroundColor: "#f8f9fa" }} src="img/About/02.jpg" alt />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className=" text-uppercase mb-2" style={{ color: "#EAA636" }}>About Us</p>
                                <h1 className="display-6 mb-4">Capturing Moments That Become Memories</h1>
                                <p>At Maa And Me Portraits, photography is our way of preserving the most beautiful chapters of your life. We don’t just take pictures — we create memories filled with emotion, warmth, and meaning. From the first breath of your newborn to the radiant glow of maternity, from playful kids and joyful cake smash moments to the closeness of family bonds, we specialize in turning life’s priceless moments into timeless art.

                                </p>
                                <p>Every story is unique, and so is the way we capture it. We take time to connect with you, understand your personality, and learn what makes your journey special. Whether you’re stepping into parenthood, celebrating a milestone, or simply wanting to freeze a moment of love, our approach is patient, heartfelt, and crafted to bring out the real you. With every click of the camera, we focus on emotions — the smiles, the innocence, the connection — the things that truly matter.</p>
                                <p>At Maa And Me Portraits, your story becomes our inspiration — and your memories become our art. ✨</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container py-5">
                    <div className="row g-4">
                        <div className="col-xl-4">
                            <div
                                className="p-4"
                                style={{
                                    backgroundColor: '#ffffff',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '16px', // Converted `p-4` to padding inline style
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    border: '1px solid #ccc',
                                    borderRadius: '12px',
                                    backgroundColor: '#f8f9fa',
                                }}      >
                                <h2 className="fw-bold text-primary">Who Are We</h2>
                                <p>
                                    At Maa And Me Portraits, we specialize in capturing the purest and most heartfelt moments of your family’s journey. From the delicate innocence of newborn photography and the radiant glow of maternity sessions to the playful charm of kids photography, the warmth of family portraits, and the joyful celebration of cake smash shoots, we bring creativity, patience, and passion to every frame. With skilled photographers, a comforting approach, and high-quality equipment, we ensure each session feels natural, memorable, and beautifully personal. Your story is unique — and we’re here to preserve it with care, artistry, and a touch of magic.
                                </p>
                            </div>
                        </div>

                        <div className="col-xl-4">
                            <div
                                className="p-4"
                                style={{
                                    backgroundColor: '#ffffff',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '16px', // Converted `p-4` to padding inline style
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    border: '1px solid #ccc',
                                    borderRadius: '12px',
                                    backgroundColor: '#f8f9fa',
                                }}      >
                                <h2 className="fw-bold text-primary">Our Mission</h2>
                                <p>
                                    At Maa And Me Portraits, our mission is to provide heartfelt, high-quality photography that beautifully preserves every stage of your family’s journey. From the tenderness of newborn days and the glowing anticipation of maternity, to the laughter of kids, the togetherness of family moments, and the joyful mess of cake smash celebrations, we aim to capture memories that feel real, emotional, and timeless. We are committed to creating a comfortable, personalized experience where every family feels valued, understood, and beautifully represented in every frame.
                                </p>
                            </div>
                        </div>

                        <div className="col-xl-4">
                            <div
                                className="p-4"
                                style={{
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "8px",
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    border: '1px solid #ccc',
                                    borderRadius: '12px',
                                    backgroundColor: '#f8f9fa',
                                }}
                            >
                                <h2 className="fw-bold text-primary">What We Do</h2>
                                <ul>
                                    <li>New Born Photography</li>
                                    <li>Maternity Photography</li>
                                    <li>Kids Photography</li>
                                    <li>Family Photography</li>
                                    <li>Cake Smash Photography</li>                                                                          
                                    <li>Portraits & More</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* About End */}
                <div className="container my-5 pb-0 mb-3">
                    <div className='row'>
                        <div className='col-xl-6 d-flex justify-content-center align-items-center mt-4'>
                            <img className="img-fluid p-3" style={{ backgroundColor: "#f8f9fa" }} src="img/About/03.jpg" alt />
                        </div>
                        <div className='col-xl-6 '>
                            <h2 className="text-center mb-4">Why Choose Us?</h2>
                            <p className="text-center">
                                We take pride in providing exceptional photography
                                services that set us apart from the rest. Here’s why you should choose
                                us for all your photography needs:
                            </p>
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                        >
                                            Creative Vision
                                        </button>
                                    </h2>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                        >
                                            Timely Delivery
                                        </button>
                                    </h2>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            Attention to Detail
                                        </button>
                                    </h2>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            Personalized Service
                                        </button>
                                    </h2>

                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            Passionate Team
                                        </button>
                                    </h2>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            Outstanding Quality
                                        </button>
                                    </h2>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button no-arrow"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            Perfect Memories
                                        </button>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default About